import { api } from '@api/api2';

export const getTicketOrigins = () => api.v1('get', 'tck/origins/list');
